import { NavLink } from '@inflearn/ds-react';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';

import { MY_URL } from '../../../constants/urls';
import { LinkCategoryTitle, NavLinkList } from './LNB';

export function PartnersMenus() {
  const { t } = useTranslation();
  return (
    <>
      <LinkCategoryTitle>{t('마케팅 파트너스')}</LinkCategoryTitle>
      <NavLinkList>
        <NavLink component={Link} label={t('파트너스 링크 생성')} href={MY_URL.PARTNERS_LINKS()} />
        <NavLink component={Link} label={t('파트너스 수익 관리')} href={MY_URL.PARTNERS()} />
      </NavLinkList>
    </>
  );
}
